import React from "react";
import PropTypes from "prop-types";
import { Tab, Table } from "semantic-ui-react";
import * as formatUtils from "../../../../app/util/formatUtils";
import * as textCodeUtils from "../../../../app/util/textCodeUtils";
import { CODIGO_TIPO_CUENTA_PASIVO_DPF } from "../../../../app/infrastructure/appConstants";

const CuentaDetailInfo = ({ cuenta, movimientos }) => {
  const panes = [
    {
      menuItem: "Detalle",
      render: () => (
        <Tab.Pane>
          <Table basic="very" size="large">
            <Table.Body>
              <Table.Row>
                <Table.Cell>Número de Cuenta:</Table.Cell>
                <Table.Cell>{cuenta.numeroCuenta}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Saldo disponible:</Table.Cell>
                <Table.Cell>
                  {`${cuenta.nombreMoneda} ${formatUtils.formatMoney(
                    cuenta.saldoDisponible
                  )}`}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Saldo contable:</Table.Cell>
                <Table.Cell>
                  {`${cuenta.nombreMoneda} ${formatUtils.formatMoney(
                    cuenta.saldoContable
                  )}`}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Moneda:</Table.Cell>
                <Table.Cell>
                  {textCodeUtils.getDescripcionMoneda(cuenta.codigoMoneda)}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Estado:</Table.Cell>
                <Table.Cell>{cuenta.estadoCuenta}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Fecha apertura:</Table.Cell>
                <Table.Cell>
                  {formatUtils.dateFormat(cuenta.fechaApertura)}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Tasa:</Table.Cell>
                <Table.Cell>{formatUtils.fomartTasa(cuenta.tasa)}</Table.Cell>
              </Table.Row>
              {cuenta.tipoCuenta === CODIGO_TIPO_CUENTA_PASIVO_DPF && (
                <>
                  <Table.Row>
                    <Table.Cell>Plazo:</Table.Cell>
                    <Table.Cell>
                      {formatUtils.fomartPlazoDPF(cuenta.plazo)}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Fecha vencimiento:</Table.Cell>
                    <Table.Cell>
                      {formatUtils.dateFormat(cuenta.fechaVencimiento)}
                    </Table.Cell>
                  </Table.Row>
                </>
              )}
              <Table.Row>
                <Table.Cell>Tipo de cuenta:</Table.Cell>
                <Table.Cell>{cuenta.tipoAhorrista}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Movimientos",
      render: () => (
        <Tab.Pane>
          <Table basic="very" size="large">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Fecha</Table.HeaderCell>
                <Table.HeaderCell>Monto</Table.HeaderCell>
                <Table.HeaderCell>Concepto</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {movimientos &&
                movimientos.map((movimiento, index) => (
                  <Table.Row key={index} negative={movimiento.signo < 0}>
                    <Table.Cell>
                      {formatUtils.dateFormat(movimiento.fechaValuta)}
                    </Table.Cell>
                    <Table.Cell>
                      {`${movimiento.nombreMoneda} ${formatUtils.formatMoney(
                        movimiento.importe * movimiento.signo
                      )}`}
                    </Table.Cell>
                    <Table.Cell>{movimiento.concepto}</Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </Tab.Pane>
      ),
    },
  ];
  return <Tab panes={panes} />;
};
CuentaDetailInfo.propTypes = {
  cuenta: PropTypes.object.isRequired,
  movimientos: PropTypes.array.isRequired,
};

export default CuentaDetailInfo;
